export default __webpack_public_path__ + "static/media/OKG-token.a9d63f4d.png";